import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func, object } from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import { SignIn } from '../../components/authentication/SignIn'
import { PagesPaths } from '../../constants/Pages'
import { initialization, stores, view } from '../../stores'
import { pushGtmTrigger } from '../../utilities/window'

class SignInPageComponent extends Component {
  async componentDidMount () {
    const { history } = this.props
    await initialization
    if (stores.authentication.isAuthententicated()) {
      history.push(PagesPaths.ACCOUNT.path)
    }
    pushGtmTrigger('login')
  }

  async onAuthenticate () {
    const { history } = this.props
    await stores.account.getAccount()
    if (stores.location.redirection) {
      history.replace(stores.location.redirection)
    } else {
      history.push(PagesPaths.ACCOUNT.path)
    }
  }

  render () {
    const { t } = this.props
    return (
      <div className='layout__container home__container--padding'>
        <div className='signin__container centered--container'>
          <div className='signin__title'>
            <h1>{t('common:signin:title')}</h1>
            <div className='flex-spacer' />
            <Link to={PagesPaths.SIGNUP.path}><button className='btn--small'>{t('common:signin:signup')}</button></Link>
          </div>
          <SignIn onAuthentication={() => this.onAuthenticate()} />
        </div>
      </div>)
  }
}

SignInPageComponent.propTypes = {
  t: func,
  history: object
}

export const SignInPage = withRouter(translate()(view(SignInPageComponent)))



// WEBPACK FOOTER //
// ./src/pages/authentification/SignInPage.js